import StripeSubscription from "../Components/Stripe/StripeSubscription";
import Header from "../Components/Header/Header";
import Footer from "../Components/Footer/Footer";
const GoPremium = () =>{
    return(
        <div className="common-bg premium-page">
            <div className="container">
            <Header/>
            <div className="padding30"></div>
                <StripeSubscription />
            <Footer />
            </div>
        </div>
    );
}
export default GoPremium;
